// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__nn7hM"};